import gsap from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import CustomEase from "gsap/CustomEase";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

gsap.registerPlugin(DrawSVGPlugin, MotionPathPlugin, CustomEase);

export default class SvgHero extends DefaultBlock {
	init() {
		const flair = this.block.querySelector(".svg-hero-flair");

		const el = {
			path: flair.querySelector(".svg-hero-flair--path"),
			star: flair.querySelector(".svg-hero-flair--star"),
			circles: flair.querySelectorAll(".svg-hero-flair--circle"),
			anchor: flair.querySelector(".svg-hero-flair--anchor"),
			anchorPath: flair.querySelector(".svg-hero-flair--anchor-path"),
			anchorRect: flair.querySelectorAll(".svg-hero-flair--anchor-rect path"),
		};
		this.el = el;

		this.initHero();
	}

	setElements() {
		gsap.set([this.el.path, this.el.star], {
			visibility: "visible",
		});

		gsap.set(this.el.anchor, {
			transformOrigin: "50% 50%",
		});

		gsap.set(this.el.anchorPath, {
			scaleX: 1,
			visibility: "visible",
		});

		gsap.set(this.el.star, {
			scale: 1,
		});

		gsap.set([this.el.circles, this.el.anchorRect], {
			scale: 1,
			visibility: "visible",
		});

		watchPreferredMotion(() => {
			gsap.set(this.el.anchorPath, {
				scaleX: 0,
				transformOrigin: "50% 50%",
				visibility: "visible",
			});

			gsap.set(this.el.star, {
				scale: 0,
			});

			gsap.set([this.el.circles, this.el.anchorRect], {
				scale: 0,
				visibility: "visible",
				transformOrigin: "center center",
			});
		});
	}

	pathMotion() {
		const pathEase = CustomEase.create(
			"custom",
			"M0,0 C0.096,0.014 0.212,0.101 0.242,0.134 0.418,0.328 0.788,0.754 1,1 "
		);

		const tl = gsap.timeline({
			repeat: -1,
			repeatDelay: 1,
			defaults: {
				ease: "back.inOut(1.1)",
			},
		});

		watchPreferredMotion(() => {
			// Path motion
			tl.fromTo(
				this.el.path,
				{
					drawSVG: 0,
				},
				{
					drawSVG: "100% 0%",
					ease: pathEase,
					duration: 2.5,
				},
				0
			);

			tl.to(
				this.el.circles,
				{
					keyframes: {
						scale: [0, 1.5, 1],
						easeEach: "back.out(1.1)",
					},
					stagger: 0.1,
					duration: 0.5,
				},
				2
			);

			tl.to(
				this.el.anchorPath,
				{
					scaleX: 1,
					duration: 1,
				},
				2.5
			);

			tl.to(
				this.el.anchorRect,
				{
					keyframes: {
						scale: [0, 1.5, 1],
						easeEach: "back.out(1.1)",
					},
					stagger: 0.1,
					duration: 0.5,
				},
				2.75
			);

			tl.to(
				this.el.anchor,
				{
					rotate: -10,
					y: -2.5,
					duration: 0.5,
				},
				2.75
			);

			// Follow star along path
			tl.to(
				this.el.star,
				{
					motionPath: {
						path: this.el.path,
						align: this.el.path,
						alignOrigin: [0.5, 0.5],
						autoRotate: true,
					},
					ease: pathEase,
					duration: 2.5,
				},
				3
			);

			tl.to(
				this.el.star,
				{
					scale: 1,
					duration: 0.5,
				},
				3
			);

			tl.to(
				this.el.path,
				{
					drawSVG: "100% 100%",
					ease: pathEase,
					duration: 2.5,
				},
				3.25
			);

			tl.to(
				this.el.anchorPath,
				{
					scaleX: 0,
					duration: 0.5,
				},
				4.25
			);

			tl.to(
				this.el.anchorRect,
				{
					keyframes: {
						scale: [1, 1.5, 0],
						easeEach: "back.out(1.1)",
					},
					stagger: 0.1,
					duration: 0.5,
				},
				4.25
			);

			tl.to(
				this.el.circles,
				{
					keyframes: {
						scale: [1, 1.5, 0],
						easeEach: "back.out(1.1)",
					},
					stagger: 0.1,
					duration: 0.5,
				},
				4.5
			);

			tl.to(
				this.el.star,
				{
					scale: 0,
					duration: 0.5,
				},
				5.75
			);
		});

		return tl;
	}

	initHero() {
		this.setElements();
		this.pathMotion();
	}
}
